import axios from "axios";
import { useState } from "react";
import { useEffect } from "react";
import SideFormWrapper from "../Components/SideFormWrapper";
import { TextInput } from "../Components/TextInput";
import "../styles/products.css";
export default function Products() {
  const [formState, setFormState] = useState(false);
  const [products, setProducts] = useState([]);
  const [formData, setFormData] = useState(null);

  const AddProductForm = () => {
    return (
      <form
        method="POST"
        onClick={(e) => {
          e.stopPropagation();
        }}
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(e);
        }}
      >
        <TextInput
          name={"product_name"}
          label={"Product Name"}
          data={formData?.product_name || ""}
        />
        <TextInput
          name={"description"}
          label={"Description"}
          data={formData?.description || ""}
        />
        <TextInput
          name={"product_price"}
          label={"Price"}
          data={formData?.product_price || ""}
        />

        <select name="category" defaultValue={formData?.category || ""}>
          <option value={"0"}>Choose Category</option>
          <option value={"Burger"}>Burger</option>
        </select>
        <select name="availability" defaultValue={formData?.availability || ""}>
          <option value={"0"}>Availablity</option>
          <option value={"true"}>Available</option>
          <option value={"false"}>Not Available</option>
        </select>
        <input name="file_upload" type={"file"} />

        <section className="btns-section">
          <button>Confirm</button>
          <button
            id="cancel-btn"
            onClick={(e) => {
              toggleForm(false);
            }}
          >
            Cancel
          </button>
        </section>
      </form>
    );
  };

  const toggleForm = (flag, edit = false, data = null) => {
    if (edit) {
      setFormData(data);
    }

    if (!flag) {
      setFormData(null);
    }
    setFormState(flag);
  };
  function handleSubmit(e, edit = false) {
    const formData_main = new FormData(e.target);
    const data = Object.fromEntries(formData_main.entries());

    if (!formData) {
      axios
        .post(`${process.env.REACT_APP_LOCAL_API_URL}/admin/products`, { data })
        .then((res) => {
          const { error } = res.data;
          if (!error) {
            setFormData(null);
            toggleForm(false);
          }
          //window.location.reload();
        });
    } else {
      axios
        .put(`${process.env.REACT_APP_LOCAL_API_URL}/admin/products`, {
          id: formData.id,
          data,
        })
        .then((res) => {
          const { error } = res.data;
          if (!error) {
            setFormData(null);
            toggleForm(false);
          }
        })
        .catch((err) => {
          alert(err);
        });
    }
  }
  function handleDelete(data) {
    axios
      .delete(`${process.env.REACT_APP_LOCAL_API_URL}/admin/products`, { data })
      .then((res) => {
        console.log(res.data);
        window.location.reload();
      })
      .catch((err) => {
        alert("Error deleting data");
        console.log("error" + err.message);
      });
  }
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_LOCAL_API_URL}/admin/products`)
      .then((res) => {
        let { data } = res.data;
        console.log(data);
        setProducts(data);
      });
  }, [formData]);

  return (
    <>
      {formState && (
        <SideFormWrapper
          children={<AddProductForm />}
          toggleForm={toggleForm}
        />
      )}
      <section className="page-title-section">
        <h1>Products</h1>
        <button
          className="btn"
          onClick={(e) => {
            toggleForm(true);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-plus-square-fill"
            viewBox="0 0 16 16"
          >
            <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0" />
          </svg>
          Add Product
        </button>
      </section>

      <table className="products-table">
        <thead>
          <tr>
            <th>Product</th>
            <th>Category</th>
            <th>Price</th>
            <th>Status</th>
            <th>Branches</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {products.map((product) => (
            <tr key={product.id}>
              <td>{product.product_name}</td>
              <td>{product.category}</td>
              <td>ETB {product.product_price.toFixed(2)}</td>
              <td>
                <span className={`status ${product.availability.toString()}`}>
                  {product.availability.toString()}
                </span>
              </td>
              <td>{""}</td>
              <td className="action-btn-wrapper">
                <button
                  id="edit-btn"
                  className="action-btn"
                  onClick={(e) => {
                    toggleForm(true, true, {
                      id: product.id,
                      product_name: product.product_name,
                      category: product.category,
                      product_price: product.product_price.toFixed(2),
                      availability: product.availability.toString(),
                      description: product.description,
                    });
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-pencil-square"
                    viewBox="0 0 16 16"
                  >
                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                    <path
                      fillRule="evenodd"
                      d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                    />
                  </svg>
                </button>
                <button
                  id="del-btn"
                  className="action-btn"
                  onClick={(e) => {
                    e.preventDefault();
                    handleDelete({
                      id: product.id,
                      product_name: product.product_name,
                      category: product.category,
                      product_price: product.product_price.toFixed(2),
                      availability: product.availability.toString(),
                    });
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-trash"
                    viewBox="0 0 16 16"
                  >
                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                  </svg>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
